module.exports = __webpack_public_path__ + "img/login-background.7eabdc22.jpg";